/**
 * SolyticsFlow — Node Types barrel export.
 *
 * Individual node components are exported for direct use by developers.
 * The `CustomNodeTypes` map is passed to ReactFlow internally.
 */
export { default as CardNode } from './CardNode';
export { default as DiamondNode } from './DiamondNode';
export { default as GroupNode } from './GroupNode';
export { default as CircleNode } from './CircleNode';
export { default as ListNode } from './ListNode';
export { default as BiDirectionalNode } from './BiDirectionalNode';

import CardNode from './CardNode';
import DiamondNode from './DiamondNode';
import GroupNode from './GroupNode';
import CircleNode from './CircleNode';
import ListNode from './ListNode';
import BiDirectionalNode from './BiDirectionalNode';

export const CustomNodeTypes = {
  cardNode: CardNode,
  diamondNode: DiamondNode,
  group: GroupNode,
  circleNode: CircleNode,
  listNode: ListNode,
  bidirectional: BiDirectionalNode,
};
